import { Card, Divider, Grid } from "@mui/material";

import Box from "../../../components/Box";
import useStrings from "../../../hooks/useStrings";

import { IPropDetailContainer } from "../../../commons/interfaces";
import Button from "../../../components/Button";
import { PolicyBasicInfo, PolicyRequirements, PolicyResources } from "../../../components/Policy";
import { useData, useSelectData, useSubmit } from "../../../hooks/policy/edit";
import { useCommonComponentContext } from "../../../providers/CommonComponentProvider";

export const PolicyEditComponent = ({
    idDetail,
    onGoBack,
    onChangeMode,
    mode,
    bRef,
}: IPropDetailContainer & {
    bRef: React.MutableRefObject<HTMLButtonElement>;
}) => {
    const Strings = useStrings();
    const { userInfo } = useCommonComponentContext();
    const { resources, services, roleGroup, roleTypeList, roles, groups, users, getAllResource, getAllService, getAllGroup, getAllRole, getUsers } =
        useSelectData();

    const {
        acUpdate,
        data,
        error,
        isEdited,
        onChangeValue,

        setError,
        onAddRequirements,
        onAddResource,
    } = useData({
        getAllResource,
        getAllService,
        idDetail,
        getAllGroup,
        getAllRole,
        getUsers,
    });

    const { onSubmit } = useSubmit({ data, mode, onChangeMode, setError, onGoBack });

    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Box display="grid" gap={2}>
                    <PolicyBasicInfo {...{ data, error, mode, onChangeValue, services }} />
                    <Divider />
                    <PolicyRequirements {...{ data, groups, mode, onAddRequirements, roles, users }} />
                    <Divider />
                    <PolicyResources {...{ data, mode, onAddResource, onChangeValue, resources }} />
                </Box>
            </Grid>
            <Button
                ref={bRef}
                onClick={onSubmit}
                sx={{
                    display: "none",
                    visibility: "visible",
                }}
            />
        </Grid>
    );
};

export default PolicyEditComponent;
